import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { FaRegCheckCircle, FaCheckCircle, FaRegCalendar } from "react-icons/fa";
import {
  SchedulingStatusCard,
  StatusContent,
  NavegationButtom,
  ScheduleInfoText,
  ScheduleDetailsWrapper,
} from "./styles";
import { SkeletonDiv } from "../Services/Sales/components/ProductInfo/styles";
import { IoMdCloseCircleOutline } from "react-icons/io";

const CREDENTIAL_SCHEDULE_STATUS = {
  NO_SCHEDULE: "NO_SCHEDULE",
  SCHEDULED: "SCHEDULED",
  COMPLETED: "COMPLETED",
};

const CREDENTIALS_ROUTE = "/staff-access/services/credentials";
const PRINTED_TAB = "3";
const MAX_SCHEDULES_DISPLAYED = 2;

export function SchedulingCardSkeleton() {
  return (
    <SchedulingStatusCard className="span">
      <SkeletonDiv width="34px" height="34px" />
      <StatusContent>
        <SkeletonDiv width="180px" height="14px" />
        <SkeletonDiv width="220px" height="14px" />
      </StatusContent>
    </SchedulingStatusCard>
  );
}

export function SchedulingCard({ scheduleStatus, loading }) {
  const intl = useIntl();
  const history = useHistory();

  const completedSchedule = useMemo(
    () =>
      scheduleStatus?.schedules?.find(
        ({ status }) => status === CREDENTIAL_SCHEDULE_STATUS.COMPLETED
      ) ?? null,
    [scheduleStatus]
  );

  const scheduledCredentials = useMemo(
    () =>
      scheduleStatus?.schedules
        ?.filter(
          ({ status }) => status === CREDENTIAL_SCHEDULE_STATUS.SCHEDULED
        )
        ?.slice(0, MAX_SCHEDULES_DISPLAYED) ?? [],
    [scheduleStatus]
  );

  if (loading) return <SchedulingCardSkeleton />;

  const { status } = scheduleStatus || {};
  const isScheduled = status === CREDENTIAL_SCHEDULE_STATUS.SCHEDULED;
  const isCompleted = status === CREDENTIAL_SCHEDULE_STATUS.COMPLETED;
  const isNoSchedule = !isScheduled && !isCompleted;

  return (
    <SchedulingStatusCard status={status} className="span">
      {isCompleted ? (
        <FaRegCheckCircle size={34} color="rgb(9, 155, 69)" />
      ) : (
        <FaRegCalendar size={34} />
      )}

      <StatusContent>
        {isCompleted && (
          <>
            <ScheduleInfoText>
              <span>{intl.formatMessage({ id: "scheduling_completed" })}</span>
            </ScheduleInfoText>
            <ScheduleInfoText>
              {intl.formatMessage({
                id: "all_scheduled_credentials_withdrawn",
              })}
            </ScheduleInfoText>
            {completedSchedule?.withdrawnAt && (
              <ScheduleInfoText>
                <FaRegCalendar size={14} />
                {` ${intl.formatMessage({ id: "withdrawn_at" })} ${
                  completedSchedule.withdrawnAt
                }`}
              </ScheduleInfoText>
            )}
          </>
        )}

        {isScheduled && (
          <>
            <ScheduleDetailsWrapper>
              <span>{intl.formatMessage({ id: "scheduling" })}:</span>{" "}
              <FaCheckCircle size={14} />{" "}
              {intl.formatMessage({ id: "scheduled" })}
            </ScheduleDetailsWrapper>
            {scheduledCredentials.map((schedule) => (
              <ScheduleInfoText key={schedule.credentialScheduleId}>
                <FaRegCalendar size={14} />
                {` ${schedule.dateSchedule} ${schedule.timeSchedule}`}
                {schedule.withdrawalPlaceName &&
                  ` - ${schedule.withdrawalPlaceName}`}
              </ScheduleInfoText>
            ))}
          </>
        )}

        {isNoSchedule && (
          <>
            <ScheduleDetailsWrapper>
              <span>{intl.formatMessage({ id: "scheduling" })}:</span>{" "}
              <IoMdCloseCircleOutline size={18} />
              {intl.formatMessage({ id: "no_schedule_label" })}
            </ScheduleDetailsWrapper>
            <ScheduleInfoText>
              {intl.formatMessage({ id: "no_schedule" })}
            </ScheduleInfoText>
          </>
        )}
      </StatusContent>

      {isScheduled && (
        <NavegationButtom
          onClick={() =>
            history.push(`${CREDENTIALS_ROUTE}?tab=${PRINTED_TAB}`)
          }
        >
          {intl.formatMessage({ id: "go_to_printed" })} {">"}
        </NavegationButtom>
      )}
    </SchedulingStatusCard>
  );
}
